import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-not-registered-dialog',
  template: `
    <div class="not-registered-container">
      <div class="icon-circle">
        <i class="fa-solid fa-user-xmark"></i>
      </div>

      <h2>Not Registered</h2>
      <p>
        This phone number is not associated with any account. Please register to
        continue.
      </p>

      <div class="register-options">
        <button class="register-btn vendor" (click)="dialogRef.close('vendor')">
          <i class="fa-solid fa-store"></i>
          <div class="btn-text">
            <span class="btn-title">Register as Vendor</span>
            <span class="btn-desc">List your equipment for rent</span>
          </div>
          <i class="fa-solid fa-chevron-right arrow"></i>
        </button>

        <button
          class="register-btn customer"
          (click)="dialogRef.close('customer')"
        >
          <i class="fa-solid fa-user"></i>
          <div class="btn-text">
            <span class="btn-title">Register as Customer</span>
            <span class="btn-desc">Rent equipment for your needs</span>
          </div>
          <i class="fa-solid fa-chevron-right arrow"></i>
        </button>
      </div>

      <button class="cancel-link" (click)="dialogRef.close()">Cancel</button>
    </div>
  `,
  styles: [
    `
      .not-registered-container {
        text-align: center;
        padding: 32px 28px 24px;
        
      }

      .icon-circle {
        width: 72px;
        height: 72px;
        border-radius: 50%;
        background: linear-gradient(135deg, #fff0f0, #ffe0e0);
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 20px;
        font-size: 28px;
        color: #e74c3c;
      }

      h2 {
        font-size: 20px;
        font-weight: 700;
        color: #222;
        margin: 0 0 8px;
      }

      p {
        font-size: 14px;
        color: #777;
        line-height: 1.5;
        margin: 0 0 28px;
      }

      .register-options {
        display: flex;
        flex-direction: column;
        gap: 12px;
        margin-bottom: 20px;
      }

      .register-btn {
        display: flex;
        align-items: center;
        gap: 14px;
        padding: 14px 16px;
        border-radius: 14px;
        border: 1.5px solid #e8e8e8;
        background: #fff;
        cursor: pointer;
        transition: all 0.2s ease;
        text-align: left;
      }

      .register-btn:hover {
        border-color: #57c4ef;
        background: #f7fbff;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(87, 196, 239, 0.12);
      }

      .register-btn > i:first-child {
        width: 42px;
        height: 42px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        flex-shrink: 0;
      }

      .register-btn.vendor > i:first-child {
        background: linear-gradient(135deg, #e8f4fd, #d0e9f8);
        color: #2980b9;
      }

      .register-btn.customer > i:first-child {
        background: linear-gradient(135deg, #e8fdf0, #d0f8e0);
        color: #27ae60;
      }

      .btn-text {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 2px;
      }

      .btn-title {
        font-size: 15px;
        font-weight: 600;
        color: #333;
      }

      .btn-desc {
        font-size: 12px;
        color: #999;
      }

      .arrow {
        color: #bbb;
        font-size: 12px;
      }

      .cancel-link {
        border: none;
        background: none;
        color: #999;
        font-size: 14px;
        cursor: pointer;
        padding: 8px 16px;
        text-decoration: underline;
        transition: color 0.2s;
      }

      .cancel-link:hover {
        color: #666;
      }
    `,
  ],
})
export class NotRegisteredDialogComponent {
  constructor(public dialogRef: MatDialogRef<NotRegisteredDialogComponent>) { }
}
